// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "@rescript/std/lib/es6/js_array.js";

var Raw = {};

var query = (require("@apollo/client").gql`
  fragment Icon on IconContentType   {
    __typename
    svg  {
      __typename
      value  {
        __typename
        name
        description
        url
        width
        height
      }
    }
  }
`);

function parse(value) {
  var value$1 = value.svg;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.value;
    tmp = {
      __typename: value$1.__typename,
      value: !(value$2 == null) ? Js_array.map((function (value) {
                if (value == null) {
                  return ;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                        __typename: value.__typename,
                        name: !(value$1 == null) ? value$1 : undefined,
                        description: !(value$2 == null) ? value$2 : undefined,
                        url: !(value$3 == null) ? value$3 : undefined,
                        width: !(value$4 == null) ? value$4 : undefined,
                        height: !(value$5 == null) ? value$5 : undefined
                      };
              }), value$2) : undefined
    };
  }
  return {
          __typename: value.__typename,
          svg: tmp
        };
}

function serialize(value) {
  var value$1 = value.svg;
  var svg;
  if (value$1 !== undefined) {
    var value$2 = value$1.value;
    var value$3 = value$2 !== undefined ? Js_array.map((function (value) {
              if (value === undefined) {
                return null;
              }
              var value$1 = value.height;
              var height = value$1 !== undefined ? value$1 : null;
              var value$2 = value.width;
              var width = value$2 !== undefined ? value$2 : null;
              var value$3 = value.url;
              var url = value$3 !== undefined ? value$3 : null;
              var value$4 = value.description;
              var description = value$4 !== undefined ? value$4 : null;
              var value$5 = value.name;
              var name = value$5 !== undefined ? value$5 : null;
              var value$6 = value.__typename;
              return {
                      __typename: value$6,
                      name: name,
                      description: description,
                      url: url,
                      width: width,
                      height: height
                    };
            }), value$2) : null;
    var value$4 = value$1.__typename;
    svg = {
      __typename: value$4,
      value: value$3
    };
  } else {
    svg = null;
  }
  var value$5 = value.__typename;
  return {
          __typename: value$5,
          svg: svg
        };
}

function verifyArgsAndParse(_Icon, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var Icon = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

export {
  Icon ,
}
/* query Not a pure module */
